<div class="d-flex justify-content-between align-items-center mb-3">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mt-2 mb-0">
      <li class="breadcrumb-item active" aria-current="page">
        <a [routerLink]="'/users/users'">Users</a>
      </li>
      <li class="breadcrumb-item" aria-current="page">
        @if (isCreate()) {
          <span class="fs-5 fw-bold mb-0">Add user</span>
        }
        @if (!isCreate()) {
          <span class="fs-5 fw-bold mb-0">Edit user</span>
        }
      </li>
    </ol>
  </nav>

  @if (loaded && user.accountManager) {
    <div (click)="clipboard.copy(getRegisterUrl())" [title]="getRegisterUrl()"
      class="btn btn-info text-light fw-bold">
      <i class="bi bi-link me-2"></i>AFFILIATE SIGNUP LINK
    </div>
  }
</div>

@if (loaded) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="card border-0 shadow mb-3 fade-in-zoom">
      <div class="card-header fw-bold bg-tertiary p-3 border-0">
        <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-person-bounding-box me-2"></i>Personal Informations</h2>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-8">
            <label for="email" class="form-label">Email</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-envelope"></i></span>
              <input type="email" id="email" class="form-control" formControlName="email"
                [readOnly]="!canChangeDev()" autocomplete="new-password">
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col">
                <label for="profile-picture" class="form-label">User Profile Picture</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-image"></i></span>
                  <input type="file" id="profile-picture" class="form-control" (change)="profilePictureUpload($event)">
                </div>
              </div>
              @if (user.image) {
                <div class="col-auto">
                  <div class="profile-picture">
                    <img [ngSrc]="imageService.getImageUrl(user.image, 128, 128)" alt="" fill>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-4">
            <label for="First Name" class="form-label">First Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <input type="text" id="First Name" class="form-control" formControlName="firstname">
            </div>
          </div>
          <div class="col-4">
            <label for="Last Name" class="form-label">Last Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <input type="text" id="Last Name" class="form-control" formControlName="lastname">
            </div>
          </div>
          <div class="col-4">
            <label for="nickName" class="form-label">Nick Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-person"></i></span>
              <input type="text" id="nickName" class="form-control" formControlName="nickname">
            </div>
          </div>
          <div class="col-4">
            <label for="teams" class="form-label">Teams</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-chat-dots"></i></span>
              <input type="text" id="teams" class="form-control" formControlName="teams">
            </div>
          </div>
          <div class="col-4">
            <label for="telegram" class="form-label">Telegram</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-telegram"></i></span>
              <input type="text" id="telegram" class="form-control" formControlName="telegram">
            </div>
          </div>
          <div class="col-4">
            <label for="mobilePhone" class="form-label">Mobile Phone</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-telephone"></i></span>
              <input type="text" id="mobilePhone" class="form-control" formControlName="phone">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card border-0 shadow mb-3 fade-in-zoom">
      <div class="card-header fw-bold bg-tertiary p-3 border-0"><h2 class="fs-6 fw-bold mb-0"><i
      class="bi bi-shield-lock me-2"></i>Security &amp; Access</h2></div>
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Authorized Countries</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
            <app-dropdown-select [multiple]="true" formControlName="authorizedCountries">
              @for (country of countries; track country) {
                <app-dropdown-select-option [value]="country.isoCode">
                  <img [ngSrc]="countryService.getFlag(country.isoCode)" width="24" height="24" class="country-flag"
                    [alt]="country.name"> {{ country }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>
          <div class="mb-3">
            <label for="authorizedIPs" class="form-label">Authorized IPs (space separated)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-laptop"></i></span>
              <input type="text" id="authorizedIPs" class="form-control" formControlName="authorizedIps">
            </div>
          </div>
          <div class="d-flex align-items-center mb-3">
            <label class="fw-bold me-3 small">Account Status:</label>
            <app-input-switch formControlName="enabled" onLabel="Enabled" offLabel="Disabled"></app-input-switch>
          </div>
          <div class="text-end">
            <button class="btn btn-primary fw-bold" (click)="regeneratePassword()" type="button">REGENERATE PASSWORD</button>
          </div>
        </div>
      </div>
      <div class="card border-0 shadow mb-3 fade-in-zoom">
        <div class="card-header fw-bold bg-tertiary p-3 border-0"><h2 class="fs-6 fw-bold mb-0"><i
        class="bi bi-filter-square me-2"></i>User type</h2></div>
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <label class="fw-bold me-3 small">Is Account Manager:</label>
            <app-input-switch onLabel="Yes" offLabel="No" formControlName="accountManager"></app-input-switch>
          </div>
          <div class="d-flex align-items-center mb-3">
            <label class="fw-bold me-3 small">Is Team Manager:</label>
            <app-input-switch onLabel="Yes" offLabel="No" formControlName="teamManager"></app-input-switch>
          </div>
          <div class="mb-3">
            <label for="selectTeam" class="form-label">Select Team</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-people"></i></span>
              <select class="form-select" formControlName="managerId" id="selectTeam">
                <option [ngValue]="null">No team</option>
                @for (manager of managers; track manager) {
                  @if (user.id !== manager.id) {
                    <option [ngValue]="manager.id">{{ manager }}</option>
                  }
                }
              </select>
            </div>
          </div>
          <div class="mb-2">
            <app-input-switch [ngModel]="hasRole('ROLE_PARTNER_AFFILIATE_ALL')"
              (ngModelChange)="setRole('ROLE_PARTNER_AFFILIATE_ALL', $event)"
              [ngModelOptions]="{standalone: true}">View All Affiliates
            </app-input-switch>
          </div>
          <div class="mb-2">
            <app-input-switch [ngModel]="hasRole('ROLE_PARTNER_MEDIABUY_ALL')"
              (ngModelChange)="setRole('ROLE_PARTNER_MEDIABUY_ALL', $event)"
              [ngModelOptions]="{standalone: true}">View All Mediabuy
            </app-input-switch>
          </div>
          <div>
            <app-input-switch [ngModel]="hasRole('ROLE_PARTNER_INTERNAL_ALL')"
              (ngModelChange)="setRole('ROLE_PARTNER_INTERNAL_ALL', $event)"
              [ngModelOptions]="{standalone: true}">View All Internal
            </app-input-switch>
          </div>
        </div>
      </div>
      <div class="card border-0 shadow mb-3 fade-in-zoom">
        <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex align-items-center justify-content-between">
          <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-unlock me-2"></i>User Rights</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              @if (canChangeDev()) {
                <select
                  [(ngModel)]="currentParentRight"
                  (change)="changeParentRole()"
                  [ngModelOptions]="{standalone: true}" class="form-control">
                <option [value]="ParentRight.DEV">DEV</option>
                <option [value]="ParentRight.SUPER_ADMIN">SUPER ADMIN</option>
                <option [value]="ParentRight.ADMIN">ADMIN</option>
                <option [value]="ParentRight.USER">USER</option>
              </select>
            }
            @if (!canChangeDev()) {
              <input class="form-control" readonly disabled value="DEV"/>
            }
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover table-striped align-middle">
            <thead>
              <tr>
                <th>Rights for</th>
                <th class="text-center">Menu</th>
                <th class="text-center">Read</th>
                <th class="text-center">Modify</th>
              </tr>
            </thead>
            <tbody>
              @for (right of rights; track right) {
                <tr>
                  <td>{{ right.name }}</td>
                  <td>
                    <div class="d-flex justify-content-center">
                      @if (right.roleAccess) {
                        <app-input-switch [ngModel]="hasRole(right.roleAccess)"
                          [disabled]="isRoleDisabled(right.roleAccess)"
                          (ngModelChange)="setRole(right.roleAccess, $event)"
                        [ngModelOptions]="{standalone: true}"></app-input-switch>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-center">
                      @if (right.roleView) {
                        <app-input-switch [ngModel]="hasRole(right.roleView)"
                          [disabled]="isRoleDisabled(right.roleView)"
                          (ngModelChange)="setRole(right.roleView, $event)"
                        [ngModelOptions]="{standalone: true}"></app-input-switch>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-center">
                      @if (right.roleUpdate) {
                        <app-input-switch [ngModel]="hasRole(right.roleUpdate)"
                          [disabled]="isRoleDisabled(right.roleUpdate)"
                          (ngModelChange)="setRole(right.roleUpdate, $event)"
                        [ngModelOptions]="{standalone: true}"></app-input-switch>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="col-12 text-end">
          <button class="btn btn-primary fw-bold" [disabled]="!canUpdate()">{{ isCreate() ? 'Create' : 'Update' }}</button>
        </div>
      </div>
    </div>
  </form>
}
